<template>
    <div class="widget-stat-chart-wrapper">
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.impressions')"
            :title-tooltip="$t('dashboard.impressionsTooltip')"
            :value="$format.number(impressions.impressions)"
            :difference="$format.percent(percentDiff(impressions.impressions, impressions.impressions_compare))"
            :loading="requestImpressionsStats.getLoading()"
            :error="requestImpressionsStats.getError()"
            tooltip-formatter="round"
        />
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.clicks')"
            :title-tooltip="$t('dashboard.clicksTooltip')"
            :value="$format.number(clicks.clicks)"
            :difference="$format.percent(percentDiff(clicks.clicks, clicks.clicks_compare))"
            :loading="requestClicksStats.getLoading()"
            :error="requestClicksStats.getError()"
            tooltip-formatter="round"
        />
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.quantity')"
            :title-tooltip="$t('dashboard.quantityTooltip2')"
            :value="$format.number(sales.quantity)"
            :difference="$format.percent(percentDiff(sales.quantity, sales.quantity_compare))"
            :loading="requestSalesStats.getLoading()"
            :error="requestSalesStats.getError()"
            tooltip-formatter="round"
        />
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.ctr')"
            :title-tooltip="$t('dashboard.ctrTooltip')"
            :value="$format.percent(clicks.clicks / impressions.impressions * 100)"
            :difference="$format.percent(percentDiff(clicks.clicks / impressions.impressions * 100, clicks.clicks_compare / impressions.impressions_compare * 100))"
            :loading="requestClicksStats.getLoading() ||requestImpressionsStats.getLoading()"
            :error="requestClicksStats.getError() ||requestImpressionsStats.getError()"
            tooltip-formatter="round"
        />
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.cr')"
            :title-tooltip="$t('dashboard.crTooltip')"
            :value="$format.percent(sales.quantity / clicks.clicks * 100)"
            :difference="$format.percent(percentDiff(sales.quantity / clicks.clicks * 100, sales.quantity_compare / clicks.clicks_compare * 100))"
            :loading="requestSalesStats.getLoading() || requestClicksStats.getLoading()"
            :error="requestSalesStats.getError() || requestClicksStats.getError()"
            tooltip-formatter="round"
        />
        <WidgetStatChart
            class="widget-stat-chart"
            :title="$t('dashboard.amount')"
            :title-tooltip="$t('dashboard.amountTooltip')"
            :value="$format.currency(sales.amount)"
            :difference="$format.percent(percentDiff(sales.amount, sales.amount_compare))"
            :loading="requestSalesStats.getLoading()"
            :error="requestSalesStats.getError()"
            tooltip-formatter="round"
        />
    </div>
</template>



<script>
    import { calculateChangePercentage } from '@/utils/number';
    import WidgetStatChart from '@/views/common/dashboard/parts/WidgetStatChart.vue';

    export default {
        name: 'StatsWidgets',
        components: {
            WidgetStatChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestSalesStats: this.parentComponent.requestSalesStats,
                requestClicksStats: this.parentComponent.requestClicksStats,
                requestImpressionsStats: this.parentComponent.requestImpressionsStats,
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        ...(this.timeRange || {}),
                    },
                };
            },
            groupBy() {
                return null;
            },
            impressions() {
                return this.requestImpressionsStats.getData() || {};
            },
            clicks() {
                return this.requestClicksStats.getData() || {};
            },
            sales() {
                return this.requestSalesStats.getData() || {};
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestSalesStats.get(this.apiParams);
                this.requestClicksStats.get(this.apiParams);
                this.requestImpressionsStats.get(this.apiParams);
            },
            percentDiff(newValue, oldValue) {
                return calculateChangePercentage(newValue, oldValue);
            },
        },
    };
</script>
